import RsvpSeatplanElements from './index';

export default {
    slug: 'rsvps/seatplan-elements',
    title: 'Rsvp Seatplan Elements',
    visible: [
        'title',
    ],
    listview: 'RsvpSeatplanElementsListView',
    locales: ['common'],
    columns: [
        {
            key: 'id',
            label: 'ID',
            main: true,
        }
    ],
    actions: {
        // create: {
        //     title: 'Add New',
        //     level: 'highlight',
        //     icon: 'plus-circle',
        //     vm: 'addNew'
        // },
        // delete: {
        //     title: 'Delete',
        //     icon: 'fa fa-remove',
        //     level: 'row',
        //     vm: 'deleteSeatplan'
        // },
        // edit: {
        //     title: 'Edit',
        //     icon: 'fa fa-edit',
        //     level: 'row',
        //     vm: 'editSeatplan'
        // },
        // details: {
        //     title: 'Delete',
        //     icon: 'fa fa-search',
        //     level: 'row',
        //     vm: 'showSeatplan'
        // },
    }
}


// WEBPACK FOOTER //
// ./src/app/store/seatplans/rse/state.js